import { pg_tileserv_url } from "../../../utils";

const ParadasBus = {
    enable: true,
    checked: false,
    initialDisplay: false,
    excludeCities: [],
    source: "pg_tileserv",
    url: pg_tileserv_url + "REPLACECITYNAME.bus_stops",
    zindex: 3,
    type: "single",
    popup: {
        default: {
            content: {
                es: {
                    layername: "Línea de bus y dirección: ",
                },
            },
            separators: {
                decimal: [],
                thousand: [],
            },
        },
    },
    titleSideBar: "Mobility Indicators Content.layers.ParadasBus",
    style: {
        regular: false,
        fillColor: "rgb(0, 106, 206)",
        strokeColor: "rgb(0, 106, 206)",
        strokeWidth: 0,
        strokeLineDash: [],
        points: 0,
        radius: 1,
        angle: 0,
        rotation: 0,
    },
    legend: {
        default: {
            title: "Mobility Indicators Content.layersLegend.ParadasBus.title",
            subtitle: "",
            attribute: "",
            symbol: "point",
            legendCustomCssClass: "map-legend-symbol-5px",
            class: [
                {
                    fillColor: "rgb(0, 106, 206)",
                    strokeColor: "rgb(0, 106, 206)",
                    strokeWidth: 0,
                    label: "Mobility Indicators Content.layersLegend.ParadasBus.classes.1",
                },
            ],
        },
    },
};

export default ParadasBus;
